export function state (cart) {
  cart.state.loyaltyThresholds = {}
  cart.state.rewards = []
  cart.state.customer_loyalty = {}
  cart.state.giftcards = []
  cart.state.activeGiftcards = []
  return cart.state
}
